import jsFormFieldEventListener from '../utils/form_field'

function initializeCweInstancePage() {
  class CwePurchaseForm {
    constructor(formElement) {
      this.formElement = formElement;
      this.loadingElement = this.formElement.parentElement.querySelector('.js-form-loading');
      this.formElement.addEventListener("submit", this._onSubmit);

      jsFormFieldEventListener(this.formElement)

      this.fieldSet = this.formElement.querySelector("fieldset")
      this.fieldSet.querySelectorAll("input").forEach(element => {
        element.addEventListener("change", event => this._setErrorMessage(event.target.name, null));
      })
      this.fieldSet.disabled = false;
    }

    _onSubmit = event => {
      event.preventDefault();

      const action = this.formElement.getAttribute("action");
      const loadingElement = this.formElement.parentElement.querySelector('.js-form-loading');
      const data = new FormData(this.formElement);

      try {
        const storageKey = 'gaTrackingParameters';
        const trackingJsonString = localStorage.getItem(storageKey) || '{}';
        let trackingData = {};

        try {
          trackingData = JSON.parse(trackingJsonString);
          if (typeof trackingData !== 'object' || trackingData === null) {
            trackingData = {};
          }
        } catch (e) {
          console.error(`Error parsing sessionStorage key "${storageKey}" during submit:`, e);
          trackingData = {};
        }

        Object.keys(trackingData).forEach(key => {
          const value = trackingData[key];
          if (value !== null && typeof value !== 'undefined') {
             data.append(key, value);
          }
        });
      } catch(e) {
         console.error('Error adding UTM metadata to FormData:', e);
      }

      this.fieldSet.disabled = true;
      loadingElement.classList.remove('hidden');

      fetch(action, { method: "POST", body: data }).then(async (response) => {
        const parsed = await response.json();

        if (response.status === 422) {
          return Promise.reject(parsed);
        }

        return parsed
      }).then(({ location }) => window.location = location)
        .catch(({ errors }) => this._handleValidationErrors(errors))
    }

    _handleValidationErrors(errors) {
      this.fieldSet.disabled = false;
      this.loadingElement.classList.add('hidden')
      this._renderErrors(errors);
    }

    _renderErrors(errors) {
      Object.keys(errors).forEach(key => this._setErrorMessage(key, errors[key][0]))
    }

    _setErrorMessage(fieldName, message) {
      const inputElement = this.fieldSet.querySelector(`input[name="${fieldName}"]`);
      const errorElement = this.fieldSet.querySelector(`[data-element='validation-error-${fieldName}']`);
      const errorMessageElement = errorElement.querySelector("[data-text=error-content]");

      inputElement.classList.toggle("ga-form-input-invalid", message);
      errorElement.classList.toggle("hidden", !message);
      errorMessageElement.textContent = message;
    }
  }

  class BottomModal {
    constructor(el) {
      this.el = el
      this.clickHandler = this._onClick.bind(this);
      this.transitionEndHandler = this._onTransitionEnd.bind(this);
    }

    open() {
      document.body.classList.add("js-bottom-modal-is-open")
      this.el.classList.add("js-is-open");
      this.el.addEventListener("click", this.clickHandler);
    }

    close() {
      this.el.removeEventListener("click", this.clickHandler);
      this.el.addEventListener("transitionend", this.transitionEndHandler);
      this.el.classList.add("js-is-closing");
      this.el.classList.remove("js-is-open");
      document.body.classList.remove("js-bottom-modal-is-open");
    }

    _onClick(e) {
      if ("close" in e.target.dataset) {
        e.stopPropagation();
        this.close();
      }
    }

    _onTransitionEnd() {
      this.el.removeEventListener("transitionend", this.transitionEndHandler);
      document.body.classList.remove("js-bottom-modal-is-open");
      this.el.classList.remove("js-is-closing");
      this.el.querySelector(".bottom-modal-content").scrollTop = 0;
    }
  }

  const forms = document.querySelectorAll(".js-cwe-enroll-form");

  if (forms.length) {
    forms.forEach(formElement => new CwePurchaseForm(formElement))
  }

  const button = document.getElementById("sticky-enroll-button");

  if (button) {
    const modalEl = document.querySelector(".bottom-modal")
    const modal = new BottomModal(modalEl);
    button.addEventListener("click", e => modal.open())
  }
};

window.initializeCweInstancePage = initializeCweInstancePage;
